import { render } from "./12PaymentInfo.vue?vue&type=template&id=5febd074"
import script from "./12PaymentInfo.vue?vue&type=script&lang=js"
export * from "./12PaymentInfo.vue?vue&type=script&lang=js"

import "./12PaymentInfo.vue?vue&type=style&index=0&id=5febd074&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__